import { useEffect, useReducer, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Form, Dropdown, Tabs, Tab, Stack, ListGroup, Image, Accordion, Button, AccordionBody, Badge, Nav, NavDropdown, DropdownToggle, DropdownMenu, DropdownItem, AccordionItem, Collapse } from "react-bootstrap";
import feedbackIcon from 'Images/feedbackloop.svg';
import { TextButton } from 'Components/Button';
import { http } from "Utils";
import { setGlobalErrorStatus, setGlobalWarningStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";

import GeneralComment from "./GeneralComment/GeneralComment";
import SearchBar from "./SearchBar";

import EventTypeSelection from "./EventTypeSelection";
import EventTypeHeader from "./EventTypeHeader";

import { commentInputDataReducer } from "./FormData/CommentsReducer";
import { commentsMatch, compareJoinedElements, containsOpenComment, getCFSplitName, getCommentTempInputData, getErrorList, logS, removeExtrasFromItemNum, validateCommentAPI, validateCommentText } from "./Util/Utilities";
import { textInputDataReducer } from "Components/Forms/FormReducers/TextInputReducer";
import ItemList from "./Accordion/ItemList";
import { COMMENT_ACTIONS, commentStateReducer } from "./FormData/CommentStateReducer";
import ThankYou from "./GeneralComment/ThankYou";
import StatusPopup from "./Util/StatusPopup";


var activeStart = [];
const OpenForComment = () => {
    const dispatch = useDispatch();
    
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState({});
    const [activeAccordion, setActiveAccordion] = useState([]);
    
    var [commentInput, commentInputDispatch] =  useReducer(textInputDataReducer, {});
    //Temporary storage for comment while modifying before it is saved to commentsList
    var [tempCommentList, tempCommentListDispatch] =  useReducer(commentStateReducer, {});


    const [activeEl, setActiveEl] = useState(null);
    const [allOpen, setAllOpen] = useState(null);
    const [statusVariant,setStatusVariant] = useState(null);
    const [statusData,setStatusData]=useState({
        title: "",
        message: "",
        buttons: null
    });

    const [comonFormatsList, setComonFormatsList] = useState(null);
    const [eventTypeList, setEventTypeList] = useState(null);

    const [tabActiveKey, setTabActiveKey] = useState(0);
    const [eventTypeActiveKey, setEventTypeActiveKey] = useState(null);
    const [catModuleData, setCatModuleData] = useState(null);
    const [moduleItems, setModuleItems] = useState(null);

    const cfDropBtnRef = useRef(0)
    var [commentsList, commentsListDispatch] =  useReducer(commentInputDataReducer, {});
    
    const [width, setWidth] = useState(window.innerWidth);
    const [mobile, setMobile] = useState(null);

    const [activeCommentKey, setActiveCommentKey] = useState(null);

   
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
            setMobile(window.innerWidth <= 575.98);
        };
        handleResize();
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(()=>{
        console.log("activeAccordion", activeAccordion);
    },[activeAccordion])

    const convertCTResp = (ctResp) => {
    
        var fieldErrors = {};
        if(ctResp.data?.errorCodeList && ctResp.data?.errorMessageList){
            var errorCodeList = ctResp.data.errorCodeList;
            var errorMessageList = ctResp.data.errorMessageList;

            for(var x = 0 ; x<errorCodeList.length ; x++){
                if(fieldErrors.hasOwnProperty([errorCodeList[x]])){
                    ((fieldErrors[errorCodeList[x]]).errorMessages).push(errorMessageList[x]);
                }
                else {
                    (fieldErrors[errorCodeList[x]]) = {
                        "fieldName": errorCodeList[x],
                        "hasError": true,
                        "errorMessages": [
                            errorMessageList[x]
                        ]
                    }
                }

                
            }
        }
        var data = {
            status: ctResp.data?.statusCode,
            data: ctResp.data?.data,
            fieldErrors: fieldErrors,
            globalErrorMessageList: [],
            message: ctResp.data?.statusDesc
        }
        return data;
    }


    const confirmCatTabChange = (e) => {
        console.log(e);
        var tempLength = Object.entries(tempCommentList)?.length;
        if(tempLength!=null && tempLength>0){
            setStatusData({
                title: "Comments have not yet been submitted!",
                message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost.",
                buttons: [
                    {
                        text: "Stay Here",
                        action: handleStatusClose,
                        variant: "comp-primary",
                        size: "lg",
                    },
                    {
                        text: "Discard Comments",
                        action: ()=>{
                            handleCatTabChange(e);
                            handleStatusClose();
                        },
                        variant: "comp-outline",
                        size: "lg",
                    }
                ]
            })
            setStatusVariant("warning");
            setShowStatusPopup(true); 
        }
        else{
            handleCatTabChange(e);
        }
    }

    const handleCatTabChange = (e, comonFormatsList) => {
        commentsListDispatch({
            type: "clear"
        });
        tempCommentListDispatch({
            type: "clear"
        });
        setIsLoading(true);
        //console.log(e);
        setTabActiveKey(e);
        
        if (e != 0) {
            getModuleList(e);
        }

    }

    const confirmModuleChange = (e) => {
        console.log(e);
        var tempLength = Object.entries(tempCommentList)?.length;
        if(tempLength!=null && tempLength>0){
            setStatusData({
                title: "Comments have not yet been submitted!",
                message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost.",
                buttons: [
                    {
                        text: "Stay Here",
                        action: handleStatusClose,
                        variant: "comp-primary",
                        size: "lg",
                    },
                    {
                        text: "Discard Comments",
                        action: ()=>{
                            handleModuleChange(e);
                            handleStatusClose();
                        },
                        variant: "comp-outline",
                        size: "lg",
                    }
                ]
            })
            setStatusVariant("warning");
            setShowStatusPopup(true); 
        }
        else{
            handleModuleChange(e);
        }
    }
    const handleModuleChange = (e) => {
        commentsListDispatch({
            type: "clear"
        });
        tempCommentListDispatch({
            type: "clear"
        });
        //setActiveModuleName(s.moduleName);
        setEventTypeActiveKey(e.id);
        setCatModuleData(e);
        getItemsList(e.groupId);
    }

    useEffect(() => {
        getCategoryList();
    }, []);

    const getCategoryList = async () => {
        console.log("%cAPI - %c%s", logS.bold, logS.colors.skyblye, "Get Common Formats List");
        const call = async () => {
            var url = "/api/ag/ct/docCatList";
            return http.post(url, null);
        }
        return call().then((res) => {
            console.log("getCategoryList ", res);
            if (res.status != 1) {
                setStatusData({
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    message: res.globalErrorMessageList[0],
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
            }
            else {
                setComonFormatsList(res?.data?.data);
            }
            return res;
        }).catch((err)=>{
                setStatusData({
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    message: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
            });
    }

    const getCFName = ()=>{ 
        console.log(comonFormatsList);
        console.log(tabActiveKey);
        if(tabActiveKey==0){
            return "General Comments";
        }
        else{
            return comonFormatsList.find((a) => a.id==tabActiveKey).shortName;
        }
    }

    const getCFNameByID = (id)=>{ 
        //console.log(comonFormatsList);
        if(id==0){
            return "General Comments";
        }
        else{
            return comonFormatsList.find((a) => a.id==id).shortName;
        }
    }

    const getModuleList = async (catId) => {
        console.log("%cAPI - %c%s%c: \n%cCommon Formats Version:%c\n%s - %s", logS.bold, logS.colors.skyblye, "Get Module List",logS.none, logS.bold, logS.none, catId, getCFNameByID(catId));
        const call = async () => {
            var url = "/api/ag/ct/document/list/module/" + catId;
            return http.post(url, null);
        }
        return call().then((resp) => { 
            //console.log("getModuleList ", resp);
            if(resp!=null){
                var res = convertCTResp(resp);
                
                if (res.status != 1) {
                    setStatusData({
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        message: res.globalErrorMessageList[0],
                        showContactHelp: true
                    })
                    setStatusVariant("error");
                    setShowStatusPopup(true); 

                }
                else {
                    var catmod = res.data;
                    var catmodlist = [];

                    for(var x = 0 ; x<catmod.length ; x++){
                        var i = catmod[x];
                        if(i!=null){
                            if(i.subModuleName==null){
                                catmodlist.push(i);
                            }
                            else{
                                //console.log(catmodlist.some(e => e.moduleName === i.moduleName));
                                if(catmodlist.some(e => e.moduleName === i.moduleName)){
                                    //console.log("contains");
                                }
                                else{
                                    var subMod = catmod.filter(a => a!=null && a.moduleName==i.moduleName);
                                    //console.log(subMod);
                                    catmodlist.push({
                                        moduleName: i.moduleName,
                                        subs: subMod
                                    });
                                }
                                
                            }
                        }
                    }
                    //console.log(catmodlist);
                    setEventTypeList(catmodlist);
                    setEventTypeActiveKey(((res.data)[0]).id)
                    setCatModuleData(((res.data)[0]));
                    getItemsList(((res.data)[0]).groupId);
                    setIsLoading(false);
                }
            }
            return res;
        }).catch((error) => {
            console.log("Error caught while loading data: " + error);

            setStatusData({
                title: ERROR_MESSAGES.DATA_ERROR.title,
                message: ERROR_MESSAGES.DATA_ERROR.message,
                showContactHelp: true
            })
            setStatusVariant("error");
            setShowStatusPopup(true); 
        });
    }

    var items = {};
    const getItemsList = async (groupId) => {
        function addNestedProperty(obj, path, keyToAdd, valueToAdd) {
            
            // Base case: If the path is empty, we are at the target object.
            if (path.length === 0) {
                if (obj.hasOwnProperty(keyToAdd)) {
                    if (obj[keyToAdd] !== null && Array.isArray(obj[keyToAdd]) ) {
                        obj[keyToAdd].push(valueToAdd);
                    }
                    else if (obj[keyToAdd] !== null && !Array.isArray(obj[keyToAdd]) ) { 
                        obj[keyToAdd] = new Array(obj[keyToAdd], valueToAdd);
                    }
                }
                else{
                    obj[keyToAdd] = valueToAdd;
                }
                activeStart.push(valueToAdd.itemNum);
                return obj;
            }

            // Recursive step: Get the current key from the path
            const currentKey = path[0];

            // Check if the current key's value is an object before recursing
            if (typeof obj[currentKey] === 'object' && obj[currentKey] !== null) {
                addNestedProperty(obj[currentKey], path.slice(1), keyToAdd, valueToAdd);
            } else {
                obj[currentKey]={};
                addNestedProperty(obj[currentKey], path.slice(1), keyToAdd, valueToAdd);
            }
            return obj;
        }

        const call = async () => {
            console.log("%cAPI - %c%s%c: \n%cModule Group ID:%c %s", logS.bold, logS.colors.skyblye, "Get Module Items",logS.none, logS.bold, logS.none, groupId, catModuleData);
            var url = "/api/ag/ct/document/list/item/" + groupId;
            return http.post(url, null);
        }
        return call().then((resp) => {
            //console.log("getItemsList ", resp);
            if(resp!=null){
                var res = convertCTResp(resp);

                if (res.status != 1) {
                    setStatusData({
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        message: res.globalErrorMessageList[0],
                        showContactHelp: true
                    })
                    setStatusVariant("error");
                    setShowStatusPopup(true); 
                }
                else {
                    setModuleItems(res.data);

                    for(var x = 0 ; x<res.data.length ; x++){
                        var item = ((res.data)[x]);

                        var num = item.itemNum;
                        var split = removeExtrasFromItemNum(num);
                        addNestedProperty(items,split,'item',item);
                    }
                    setAllOpen([...activeStart]);
                    setActiveAccordion([...activeStart]);
                    
                    setEvents(items);
                    //console.log(items);
                    setIsLoading(false);
                }
            }
            return res;
        }).catch((error) => {
            console.log(error);

            setStatusData({
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    message: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                })
                setStatusVariant("error");
                setShowStatusPopup(true); 
        });
    }

    

    

    const handleActiveCommentChange = async (newId,checkEmpty) => {
            console.log("%cInitiate %c- Active Key Change %c- %s -> %s", logS.bold, logS.colors.purple, logS.bold, activeCommentKey, newId, tempCommentList);
            var isSuccess = false;
            if(tempCommentList!=null && newId!=null){
                const entriesArray = Object.entries(tempCommentList);
                const filteredEntries = entriesArray.filter(([key, value]) => {
                    return (value.status === "add" || value.status === "edit") && (newId!=null && newId!=key);
                });
    
                if(filteredEntries.length>0){
                    var change = null;
                    const results = await Promise.all(
                        filteredEntries.map(async entry => {
                            console.log(entry);
                            try {
                                var id = entry[0];
                                var value = entry[1];
    
                                var s = getCommentTempInputData(tempCommentList,id,"status");
                                var d = getCommentTempInputData(tempCommentList,id,"input");

                                const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );

                                if(s=="edit"){
                                    checkEmpty=true;
                                }
                                else{
                                    checkEmpty=false;
                                }

                                var r = getErrorList(e);
                                var result = {
                                    item: getCommentTempInputData(tempCommentList,id),
                                    errors: r
                                }
                                return result;
                            } 
                            catch (err) {
                                console.error(`Failed to validate ${id}`, err);
                                return;
                            }
                        })
                    );
                    console.log(results);
    
                    for(var x = 0 ; x<results.length ; x++){
                        var r = results[x].errors;
                        var item = results[x].item;
                        
                        var id = item.item.id;
                        var s = getCommentTempInputData(tempCommentList,id,"status");
                        var d = getCommentTempInputData(tempCommentList,id,"input");
                        if(r!=null && r.length>0){
                            var arr = [];
                            var isEmpty = false;
    
                            if(s!=null){
                                if(s=="add"){
                                    for(var x = 0 ; x<r.length ; x++){
                                        if(r[x].code==200){
                                            isEmpty=true;
                                        }
                                        else{
                                            arr.push(r[x].msg);
                                        }
                                    }
                                    if(isEmpty==true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                            id: d.name
                                        });
                                    }
                                    else{
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });

                                        console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.InputRef.current) {
                                            (d.InputRef.current).focus();
                                        }
                                    }
                                }
                                if(s=="edit"){
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: "update-comment-status",
                                            name: id,
                                            status: 'view'
                                        })
                                    }
                                    else{
                                        for(var x = 0 ; x<r.length ; x++){
                                            console.log(r[x]);
                                            arr.push(r[x].msg);
                                        }
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });
                                        
                                        console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.EditRef.current) {
                                            (d.EditRef.current).focus();
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            if(change==null){
                                change=true;
                            }
                            var i = getCommentTempInputData(tempCommentList,id,"item");
                            console.log(s);
                            console.log(i);
                            console.log(d);
                            if(s!=null){
                                if(s==="add"){
                                    // tempCommentListDispatch({
                                    //     type: "update-comment-status",
                                    //     name: id,
                                    //     status: 'view'
                                    // })
                                    commentsListDispatch({
                                        type: "add-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    });
                                }
                                if(s==="edit"){
                                    // tempCommentListDispatch({
                                    //     type: "update-comment-status",
                                    //     name: id,
                                    //     status: 'view'
                                    // })
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                        commentsListDispatch({
                                            type: "update-comment",
                                            input: d,
                                            item: i,
                                            date: new Date()
                                        })
                                    }
                                }
                            }
                            tempCommentListDispatch({
                                type: "update-comment-status",
                                name: id,
                                status: 'view'
                            })
                        }
                    }
                    
                    if(change==true){
                        setActiveCommentKey(newId);
                        isSuccess=true;
                    }
                }
                else{
                    setActiveCommentKey(newId);
                    isSuccess=true;
                }
            }
    
            if(isSuccess==true){
                
                console.log("%cActive Key Change - %cSuccess%c - %s -> %s", logS.colors.purple, logS.colors.green, logS.bold,activeCommentKey, newId, tempCommentList);
            }
            else{
                
                console.log("%cActive Key Change - %cFailed%c - %s -> %s", logS.colors.purple, logS.colors.red, logS.bold,activeCommentKey, newId, tempCommentList);
            }
            return isSuccess;
        }

        
    const handleAddToAcc = (newTodo) => {
        setActiveAccordion(prevTodos => [...prevTodos, newTodo]);
    };

    const validateSubmitAll = async ()=>{
        if(tempCommentList!=null){
            const entriesArray = Object.entries(tempCommentList);
            const filteredEntries = entriesArray.filter(([key, value]) => {
                return (value.status === "add" || value.status === "edit");
            });
            if(Object.entries(filteredEntries).length<1){
                setShowPopup(true);
            }
            else{ 
                console.log(filteredEntries);
                var change = null;
                const results = await Promise.all(
                    filteredEntries.map(async entry => {
                        var checkEmpty = null;
                        console.log(entry);
                        try {
                            var id = entry[0];
                            var value = entry[1];

                            var s = getCommentTempInputData(tempCommentList,id,"status");
                            var d = getCommentTempInputData(tempCommentList,id,"input");
                            const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );
                            console.log(e);
                            if(s=="edit"){
                                checkEmpty=true;
                            }
                            else{
                                checkEmpty=false;
                            }
                            var r = getErrorList(e);
                            var result = {
                                item: getCommentTempInputData(tempCommentList,id),
                                errors: r
                            }
                            return result;
                        } catch (err) {
                            console.error(`Failed to fetch user ${id}`, err);
                            return { id, name: 'Unknown User' }; // fallback value
                        }
                    })
                );
                console.log(results);
                var expand = [];
                for(var x = 0 ; x<results.length ; x++){
                    var r = results[x].errors;
                    var item = results[x].item;
                    console.log(item);
                    var id = item.item.id;
                    var s = getCommentTempInputData(tempCommentList,id,"status");
                    var d = getCommentTempInputData(tempCommentList,id,"input");
                    if(r!=null && r.length>0){
                        var arr = [];
                        var isEmpty = false;

                        if(s!=null){
                            if(s=="add"){
                                for(var x = 0 ; x<r.length ; x++){
                                    if(r[x].code==200){
                                        isEmpty=true;
                                    }
                                    else{
                                        arr.push(r[x].msg);
                                    }
                                }
                                if(isEmpty==true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                        id: d.name
                                    });
                                }
                                else{
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.InputRef.current) {
                                        (d.InputRef.current).focus();
                                    }
                                }
                            }
                            if(s=="edit"){
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                    if(change==null){
                                        change=true;
                                    }
                                    tempCommentListDispatch({
                                        type: "update-comment-status",
                                        name: id,
                                        status: 'view'
                                    })
                                }
                                else{
                                    for(var x = 0 ; x<r.length ; x++){
                                        console.log(r[x]);
                                        arr.push(r[x].msg);
                                    }
                                    change=false;
                                    tempCommentListDispatch({
                                        type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                        errors: arr,
                                        name: d.name
                                    });

                                    

                                    console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                    if (d.EditRef.current) {
                                        (d.EditRef.current).focus();
                                    }
                                }
                            }
                        }
                    }
                    else{
                        if(change==null){
                            change=true;
                            
                        }
                        var i = getCommentTempInputData(tempCommentList,id,"item");
                        
                        if(s!=null){
                            if(s=="add"){
                                commentsListDispatch({
                                    type: "add-comment",
                                    input: d,
                                    item: i,
                                    date: new Date()
                                });
                            }
                            if(s=="edit"){
                                
                                if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                    commentsListDispatch({
                                        type: "update-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    })
                                }
                            }
                        }

                        tempCommentListDispatch({
                            type: "update-comment-status",
                            name: id,
                            status: 'view'
                        })
                        
                    }
                }
                if(change==true){
                    setShowPopup(true);
                }
            }
        }
    }
    const toggleAll = async (action) => {
        if(action == "expand"){
            setActiveAccordion(allOpen);
        }
        if(action == "collapse"){
            

            if(tempCommentList!=null){
                const entriesArray = Object.entries(tempCommentList);
                const filteredEntries = entriesArray.filter(([key, value]) => {
                    return (value.status === "add" || value.status === "edit");
                });
                if(Object.entries(filteredEntries).length<1){
                    setActiveAccordion([]);
                }
                else{ 
                    //setActiveAccordion([]);
                    console.log(filteredEntries);
                    var change = null;
                    const results = await Promise.all(
                        filteredEntries.map(async entry => {
                            var checkEmpty = null;
                            console.log(entry);
                            try {
                                var id = entry[0];
                                var value = entry[1];

                                var s = getCommentTempInputData(tempCommentList,id,"status");
                                var d = getCommentTempInputData(tempCommentList,id,"input");
                                const e = await validateCommentAPI(d.value, tabActiveKey, id, false,id );
                                console.log(e);
                                if(s=="edit"){
                                    checkEmpty=true;
                                }
                                else{
                                    checkEmpty=false;
                                }
                                var r = getErrorList(e);
                                var result = {
                                    item: getCommentTempInputData(tempCommentList,id),
                                    errors: r
                                }
                                return result;
                            } catch (err) {
                                console.error(`Failed to fetch user ${id}`, err);
                                return { id, name: 'Unknown User' }; // fallback value
                            }
                        })
                    );
                    console.log(results);
                    var expand = [];
                    for(var x = 0 ; x<results.length ; x++){
                        var r = results[x].errors;
                        var item = results[x].item;
                        console.log(item);
                        var id = item.item.id;
                        var s = getCommentTempInputData(tempCommentList,id,"status");
                        var d = getCommentTempInputData(tempCommentList,id,"input");
                        if(r!=null && r.length>0){
                            var arr = [];
                            var isEmpty = false;

                            if(s!=null){
                                if(s=="add"){
                                    for(var x = 0 ; x<r.length ; x++){
                                        if(r[x].code==200){
                                            isEmpty=true;
                                        }
                                        else{
                                            arr.push(r[x].msg);
                                        }
                                    }
                                    if(isEmpty==true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.REMOVE_COMMENT,
                                            id: d.name
                                        });
                                    }
                                    else{
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });

                                        
                                        var num = item.item.itemNum;
                                        var numSplit = removeExtrasFromItemNum(num);
                                        for(var x = 1 ; x<=numSplit.length ; x++){
                                            var s = numSplit.slice(0,x);
                                            var joined = s.join(".");
                                            if(x==1){
                                                joined = joined + ".0";
                                            }
                                            console.log(x);
                                            console.log(joined);
                                            expand.push(joined);
                                            handleAddToAcc(joined);
                                        }
                                        console.log(numSplit);
                                        

                                        console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.InputRef.current) {
                                            (d.InputRef.current).focus();
                                        }
                                    }
                                }
                                if(s=="edit"){
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) == true){
                                        if(change==null){
                                            change=true;
                                        }
                                        tempCommentListDispatch({
                                            type: "update-comment-status",
                                            name: id,
                                            status: 'view'
                                        })
                                    }
                                    else{
                                        for(var x = 0 ; x<r.length ; x++){
                                            console.log(r[x]);
                                            arr.push(r[x].msg);
                                        }
                                        change=false;
                                        tempCommentListDispatch({
                                            type: COMMENT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: arr,
                                            name: d.name
                                        });

                                        var num = item.item.itemNum;
                                        var numSplit = removeExtrasFromItemNum(num);
                                        for(var x = 1 ; x<=numSplit.length ; x++){
                                            var s = numSplit.slice(0,x);
                                            var joined = s.join(".");
                                            if(x==1){
                                                joined = joined + ".0";
                                            }
                                            console.log(x);
                                            console.log(joined);
                                            expand.push(joined);
                                            handleAddToAcc(joined);
                                        }
                                        console.log(numSplit);

                                        console.log("%cFocus %c- %s -", logS.colors.blue, logS.bold, item.item.itemNum, d);
                                        if (d.EditRef.current) {
                                            (d.EditRef.current).focus();
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            if(change==null){
                                change=true;
                            }
                            var i = getCommentTempInputData(tempCommentList,id,"item");
                            
                            if(s!=null){
                                if(s=="add"){
                                    commentsListDispatch({
                                        type: "add-comment",
                                        input: d,
                                        item: i,
                                        date: new Date()
                                    });
                                }
                                if(s=="edit"){
                                    
                                    if(commentsList!=null && commentsList.hasOwnProperty(id) && commentsMatch(commentsList[id].input.value, d.value) != true){
                                        commentsListDispatch({
                                            type: "update-comment",
                                            input: d,
                                            item: i,
                                            date: new Date()
                                        })
                                    }
                                }
                            }

                            tempCommentListDispatch({
                                type: "update-comment-status",
                                name: id,
                                status: 'view'
                            })
                            
                        }
                    }
                    
                    console.log(expand);
                    setActiveAccordion(expand);
                    console.log("%cInitiate - %cAccordion%c - %s", logS.bold, logS.colors.teal, logS.bold,"Collapse All");
                    
                }
            }
        }
            
    } 

    
    const [open, setOpen] = useState(false);
    const [expanded,setExpanded] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const [showStatusPopup, setShowStatusPopup] = useState(true);
    

    const handleClose = () => {
        setShowPopup(false);
    }
    const handleStatusClose = () => {
        setShowStatusPopup(false);
    }
    return (
        <>
            {showPopup == true
                ?   <ThankYou
                        show={showPopup}
                        handleClose={handleClose}
                        comments={commentsList}
                        submitType={"cf"}
                        categoryId={tabActiveKey}
                        tempCommentListDispatch={tempCommentListDispatch}
                        commentsListDispatch={commentsListDispatch}
                        setStatusData={setStatusData}
                        setStatusVariant={setStatusVariant}
                        setShowStatusPopup={setShowStatusPopup}
                    >
                    </ThankYou>
                :   null
            }
            {
                showStatusPopup == true && statusVariant != null
                ?
                    <StatusPopup
                        show={showStatusPopup}
                        handleClose={handleStatusClose}
                        title={statusData.title}
                        variant={statusVariant}
                        message={statusData.message}
                        buttons={statusData.buttons}
                        showStatusPopup={statusData?.showContactHelp}
                    ></StatusPopup>
                :   null
            }
            
            <Row className="m-0 p-0 gap-80 commenting-tool">
                <div className="public-header m-0 d-flex flex-column justify-content-center w-100 g-0">
                    <Row className="d-flex flex-column flex-md-row justify-content-center w-100 m-0 p-0 gap-4 gap-0 g-4 horiz-header col-xxl-9 col-xl-11 col-lg-11 col-md-11 col-sm-12" >
                            <Col className={"d-flex flex-column pe-md-3 gap-4 g-0 mt-0 pt-0"} md={6} lg={6} xl={6} xxl={5}>
                                <h1 id="mainContent" className={"displayXL bold color-white text-center text-md-start mb-0"}>Provide Feedback</h1>
                                <p className="body  public-intro text-center text-md-start mb-0" >
                                    To improve the Common Formats, we need your feedback. Use the form below to provide your real world input and perspective. The PSOPPC will then convene a Common Formats Expert Panel will review submitted public comments and provide recommendations to AHRQ for how to update existing, or create new Common Formats. 
                                </p> 
                            </Col>
                            <Col className={"pb-0 d-flex justify-content-center ps-md-3 mt-0 g-0"} md={5} lg={5} xl={5} xxl={4}>
                                <img src={feedbackIcon} alt="Feedback Loop" className="feedback-loop"></img>
                            </Col>
                    </Row>
                </div>
                <Row className=" m-0 p-0 d-flex justify-content-center">
                    <Col xxl={9} xl={11} lg={11} md={11} sm={12} className="px-3 px-md-0">
                        <h2 className="bold displayS color-193F64 mb-4 text-start">Commenting Tool</h2>
                        <p className="body semilight text-start mb-4">
                            You can search for terms directly across all versions or browse by a specific Common Formats version or provide feedback on specific Common Format versions’ individual event descriptions. For broader feedback, use the General tab.
                        </p>
                        <p className="body semilight text-start mb-0">
                            Please select the <b>Common Formats version</b> you're interested in providing feedback.
                        </p>
                        <ul className="ctul body semilight text-start mb-0">
                            <li>Choose an <b>event type</b> below to load its descriptions.</li>
                            <li>Select any element to enter your comments.</li>
                            <li>Upon selection, a text box will appear near the <b>individual element.</b></li>
                            <li>Click <b>Submit All Comments</b>  to finalize your feedback for this version.</li>
                        </ul>
                        <p className="d-block d-md-none body semilight text-start mb-0 mt-4"><i>For a better provide feedback experience, consider using the desktop format.</i></p>
                    </Col>
                    
                </Row>
                
                {/**commenting tool section */}
                <Row className="justify-content-center comment-tool-card p-0 m-0 ">
                    {/* <div className="d-flex flex-row justify-content-start gap-2">
                        <Button onClick={()=>{
                            setStatusData({
                                title: "Success!",
                                message: "We've captured your comments; thank you for your feedback."
                            })
                            setStatusVariant("success");
                            setShowStatusPopup(true); 
                        }}>
                            Success
                        </Button>
                        <Button onClick={()=>{
                            setStatusData({
                                title: "Data Error",
                                showContactHelp: true,
                                message: "Unable to load data. "
                               
                            })
                            setStatusVariant("error");
                            setShowStatusPopup(true); 
                        }}>
                            Error
                        </Button>
                        <Button onClick={()=>{
                            setStatusData({
                                title: "Comments have not yet been submitted!",
                                message: "You may only enter comments for one version at a time. Are you sure you want to navigate away? There are unsubmitted comments. If you leave, your comments will be lost."
                            })
                            setStatusVariant("warning");
                            setShowStatusPopup(true); 
                        }}>
                            Warning
                        </Button>
                        <Button onClick={()=>{
                            setStatusData({
                                title: "Information",
                                message: "A code has been sent to your registered cell phone. Please enter that code in the field below. You may send a new code after 30 seconds if needed."
                            })
                            setStatusVariant("info");
                            setShowStatusPopup(true); 
                        }}>
                            Info
                        </Button>
                    </div> */}
                    <Col xxl={11} xl={12} lg={12} md={12} sm={12} className="p-0">
                        <Card className="mb-80px ct-blue-bg-card" >
                            <Card.Body className="text-start p-0 d-flex flex-column gap-4">
                                <Col className="d-flex flex-column flex-lg-row justify-content-between gap-4">
                                    <Col sm={12} md={8} lg={7}  className="p-0">
                                        <SearchBar></SearchBar>
                                    </Col>
                                    <Col lg="auto" className="p-0">
                                        {
                                            tabActiveKey!=0 
                                            ?   
                                                <TextButton
                                                    id="ct-save-all-btn"
                                                    content="Submit All Comments"
                                                    variant="comp-primary"
                                                    size="lg"
                                                    className="ms-md-auto px-80px body w-xs-100 w-lg-fit-content "
                                                    onClick={()=>{
                                                        const entriesArray = Object.entries(tempCommentList);
                                                        console.log(entriesArray);
                                                        if(entriesArray!=null && entriesArray.length>0){
                                                            validateSubmitAll();
                                                        }
                                                        else{
                                                            setStatusData({
                                                                title: "Submission Error",
                                                                message: "At least one comment is required. Please add a comment.",
                                                                buttons: null
                                                            })
                                                            setStatusVariant("warning");
                                                            setShowStatusPopup(true); 
                                                        }
                                                    }}
                                                ></TextButton>
                                            :   null
                                        }
                                    </Col>
                                </Col>  
                            
                                <Tab.Container
                                    id="ct-tabs"
                                    activeKey={tabActiveKey}
                                    defaultActiveKey={0}
                                    mountOnEnter={true}
                                    unmountOnExit={true}
                                    variant="ct"
                                >
                                    {/* <Accordion.Body> */}
                                    <div className="my-0 bg-color-base-white floating">
                                        <Button
                                            className="d-flex d-lg-none body bold"
                                            onClick={() => setOpen(!open)}
                                            aria-controls="ct-drop-menu"
                                            aria-expanded={open}
                                            variant="ct-drop"
                                            ref={cfDropBtnRef}
                                        >
                                            {getCFName()}
                                            <svg className={open==false ? "down-icon" : 'up-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                                <path d="M1.41 7.41L6 2.83L10.59 7.41L12 6L6 3.8147e-06L0 6L1.41 7.41Z" fill="#1D6193"/>
                                            </svg>
                                        </Button>
                                        <Collapse id="ct-drop-menu" in={open} appear={false} timeout={0} className="d-lg-block ct-drop-menu">
                                            <div>
                                                <Nav 
                                                    id="ct-tabs"
                                                    onSelect={(k) => {
                                                        console.log(k);
                                                        confirmCatTabChange(k);
                                                        setOpen(false);
                                                        (cfDropBtnRef.current).focus();
                                                    }}
                                                    variant="ct" 
                                                >
                                                    <>
                                                        {
                                                            comonFormatsList != null
                                                            ? 
                                                                comonFormatsList.map((cat, index) => {
                                                                    if(cat.opForCmnt==1){
                                                                        var {name, version} = getCFSplitName(cat.shortName);
                                                                        return ( 
                                                                            <Nav.Item key={cat.id}>
                                                                                <Nav.Link eventKey={cat.id} as={"button"}  role={"navigation"} disabled={cat.id == tabActiveKey ? "disabled" : ""}>
                                                                                    <div className="d-none d-lg-flex flex-column align-items-center">
                                                                                        <div className="d-flex flex-row position-absolute align-items-center">
                                                                                            <span className="tab-name">{name}</span>
                                                                                            <Badge bg="version">{version}</Badge>
                                                                                        </div>
                                                                                        <div aria-hidden="true" className=" hide d-flex flex-row align-items-center">
                                                                                            <span className="bold-sizer" >{name}</span>
                                                                                            <Badge className="hide-ver" bg="version">{version}</Badge>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex d-lg-none flex-column align-items-start">
                                                                                        <div className="d-flex flex-row position-relative align-items-start">
                                                                                            <span className="tab-name">{cat.shortName}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </Nav.Link>
                                                                            </Nav.Item>
                                                                        );
                                                                    }
                                                                })
                                                            :   null
                                                        }
                                                        <Nav.Item>
                                                            <Nav.Link eventKey={0} as={"button"} role={"navigation"} disabled={0 == tabActiveKey ? "disabled" : ""}>
                                                                <div className="d-none d-lg-flex flex-column align-items-center">
                                                                    <div className="d-flex flex-row position-absolute align-items-center">
                                                                        <span className="tab-name">General</span>
                                                                    </div>
                                                                    <div aria-hidden="true" className=" hide d-flex flex-row align-items-center">
                                                                        <span className="bold-sizer" >General</span>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex d-lg-none flex-column align-items-start">
                                                                    <div className="d-flex flex-row position-relative align-items-start">
                                                                        <span className="tab-name">General Comments</span>
                                                                    </div>
                                                                </div>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    </>
                                                </Nav>
                                            </div>
                                        </Collapse>
                                    </div>
                                    {/* </Accordion.Body> */}
                                    
                                    
                                    <Tab.Content>
                                        <Tab.Pane eventKey={tabActiveKey}>
                                            {
                                                tabActiveKey==0 
                                                ?   <GeneralComment 
                                                        setStatusData={setStatusData}
                                                        setStatusVariant={setStatusVariant}
                                                        setShowStatusPopup={setShowStatusPopup}
                                                    ></GeneralComment>
                                                :   
                                                    <div className="d-flex flex-column gap-4 mt-0">
                                                        {
                                                            eventTypeList!=null && eventTypeList.length>1 && eventTypeActiveKey!=null
                                                            ?   
                                                                <EventTypeSelection
                                                                    activeKey={eventTypeActiveKey}
                                                                    setActiveKey={setEventTypeActiveKey}
                                                                    handleModuleChange={confirmModuleChange}
                                                                    eventTypeList={eventTypeList}
                                                                    setEventTypeList={eventTypeList}
                                                                ></EventTypeSelection>
                                                                
                                                            : null
                                                        }
                                                        {
                                                            catModuleData!=null 
                                                            ?
                                                                <EventTypeHeader shortName={catModuleData.shortName} displayName={catModuleData.dispName} toggleAll={toggleAll} categoryId={tabActiveKey} cfName={getCFName()}></EventTypeHeader>
                                                            : null
                                                        }
                                                        {
                                                            events!=null && isLoading==false 
                                                            ?
                                                                <ItemList
                                                                    events={events}
                                                                    activeAccordion={activeAccordion} 
                                                                    setActiveAccordion={setActiveAccordion}
                                                                    activeEl={activeEl} 
                                                                    setActiveEl={setActiveEl} 
                                                                    commentsList={commentsList}
                                                                    commentsListDispatch={commentsListDispatch}
                                                                    moduleItems={moduleItems}
                                                                    mobile={mobile}
                                                                    commentInput={commentInput}
                                                                    commentInputDispatch={commentInputDispatch}
                                                                    tempCommentList={tempCommentList}
                                                                    tempCommentListDispatch={tempCommentListDispatch}
                                                                    activeCommentKey={activeCommentKey}
                                                                    setActiveCommentKey={setActiveCommentKey}
                                                                    categoryId={tabActiveKey}
                                                                    handleActiveCommentChange={handleActiveCommentChange}

                                                                    handleStatusClose={handleStatusClose}
                                                                    setStatusData={setStatusData}
                                                                    setStatusVariant={setStatusVariant}
                                                                    setShowStatusPopup={setShowStatusPopup}
                                                                ></ItemList>
                                                            :   null
                                                        }
                                                        
                                                    </div>
                                            }
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Row>
        </>
    )
}

export default OpenForComment;